import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-icon',
  templateUrl: './icc-icon.component.html',
  styles: [],
})
export class IccIconComponent implements OnInit {
  constructor() {}
  // 默认图标地址
  @Input() icon: string;
  // 悬浮图标地址
  @Input() hoverIcon: string;
  // 是否称满外层
  @Input() isHundredWidth: boolean = false;
  // 点击事件
  @Output() iconClick: EventEmitter<any> = new EventEmitter<any>();
  isHover: boolean;
  ngOnInit() {}
  imgClick() {
    this.iconClick.emit();
  }
}
